var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import * as Styled from './OverlayFooter.styled';
import { AnimatedButtonTag } from '../../../../ButtonTag/ButtonTag';
import Button from '../../../../Button/Button';
var OverlayFooter = function (props) {
    var primaryButton = props.primaryButton, onClickPrimaryButton = props.onClickPrimaryButton, secondaryButton = props.secondaryButton, onClickSecondaryButton = props.onClickSecondaryButton, children = props.children, onRemoveTag = props.onRemoveTag, tags = props.tags;
    return (React.createElement(Styled.DialogFooter, null,
        tags && React.createElement(Styled.ButtonTags, null, tags.map(function (tag) { return (React.createElement(AnimatedButtonTag, __assign({}, tag, { key: tag.id, onDelete: function () { return onRemoveTag && onRemoveTag(tag.id); } }))); })),
        !!primaryButton && !!secondaryButton &&
            React.createElement(Styled.Buttons, null,
                !!primaryButton && React.createElement(Button, { onClick: onClickPrimaryButton, variant: 'primary' }, primaryButton),
                !!secondaryButton && React.createElement(Button, { onClick: onClickSecondaryButton, variant: 'secondary' }, secondaryButton)),
        children));
};
export default OverlayFooter;
